// src/components/PrivateRoute.jsx
import React from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function PrivateRoute() {
  const { currentUser, globalLoading } = useAuth()
  const location = useNavigate()

  if (globalLoading) {
    return <LoadingSpinner />
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
